const isNonEmptyObject = (input) => Object.keys(input).length > 0;
export {
  isNonEmptyObject
};
//# sourceMappingURL=is-non-empty-object.js.map
